/**
 * @flow
 * @relayHash b4122cb82a9c700c983e6049c9374da3
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type VerifyTokenMutationVariables = {|
  token: string
|};
export type VerifyTokenMutationResponse = {|
  +verifyToken: ?{|
    +payload: ?any
  |}
|};
export type VerifyTokenMutation = {|
  variables: VerifyTokenMutationVariables,
  response: VerifyTokenMutationResponse,
|};
*/

/*
mutation VerifyTokenMutation(
  $token: String!
) {
  verifyToken(token: $token) {
    payload
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = [
      {
        kind: "LocalArgument",
        name: "token",
        type: "String!",
        defaultValue: null,
      },
    ],
    v1 = [
      {
        kind: "LinkedField",
        alias: null,
        name: "verifyToken",
        storageKey: null,
        args: [
          {
            kind: "Variable",
            name: "token",
            variableName: "token",
            type: "String",
          },
        ],
        concreteType: "Verify",
        plural: false,
        selections: [
          {
            kind: "ScalarField",
            alias: null,
            name: "payload",
            args: null,
            storageKey: null,
          },
        ],
      },
    ];
  return {
    kind: "Request",
    operationKind: "mutation",
    name: "VerifyTokenMutation",
    id: null,
    text:
      "mutation VerifyTokenMutation(\n  $token: String!\n) {\n  verifyToken(token: $token) {\n    payload\n  }\n}\n",
    metadata: {},
    fragment: {
      kind: "Fragment",
      name: "VerifyTokenMutation",
      type: "Mutations",
      metadata: null,
      argumentDefinitions: v0,
      selections: v1,
    },
    operation: {
      kind: "Operation",
      name: "VerifyTokenMutation",
      argumentDefinitions: v0,
      selections: v1,
    },
  };
})();
// prettier-ignore
(node/*: any*/).hash = 'bd4dc5bbe33516247907773cb7d5a497';
module.exports = node;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/VerifyTokenMutation.graphql.js